var _excluded = ["title", "subTitle", "nextSectionBackgroundColor", "images", "imageDescription", "children", "variation", "className"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from "react";
import { Stack, Container } from "@nib/layout";
import Heading from "@nib-components/heading";
import colors from "@nib-components/colors";
import { HeroPanelWrapper, HeroPanelMain, Flex, ContentBox, validVariationValues } from "./layoutComponents";

var HeroPanel = function HeroPanel(props) {
  // eslint-disable-next-line react/prop-types
  var title = props.title,
      subTitle = props.subTitle,
      nextSectionBackgroundColor = props.nextSectionBackgroundColor,
      images = props.images,
      _props$imageDescripti = props.imageDescription,
      imageDescription = _props$imageDescripti === void 0 ? "" : _props$imageDescripti,
      children = props.children,
      variation = props.variation,
      className = props.className,
      otherProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(HeroPanelWrapper, _extends({
    variation: variation,
    nextSectionBackgroundColor: nextSectionBackgroundColor,
    className: className
  }, otherProps), /*#__PURE__*/React.createElement(HeroPanelMain, _extends({
    variation: variation,
    images: images,
    nextSectionBackgroundColor: nextSectionBackgroundColor
  }, otherProps), /*#__PURE__*/React.createElement("span", {
    role: "img",
    "aria-label": imageDescription
  }), /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Flex, {
    variation: variation
  }, /*#__PURE__*/React.createElement(ContentBox, {
    variation: variation
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 4
  }, title && /*#__PURE__*/React.createElement(Heading, {
    component: "h1",
    size: {
      xs: 2,
      md: 1
    },
    fontType: "serif",
    color: "trueGreen"
  }, title), subTitle && /*#__PURE__*/React.createElement(Heading, {
    size: 3,
    component: "p"
  }, subTitle), children))))));
};

HeroPanel.displayName = "HeroPanel";
HeroPanel.defaultProps = {
  nextSectionBackgroundColor: colors.white,
  variation: "full"
};
export default HeroPanel;